import initialData from './initial-data';

export default {
  initialData,
};
